import * as React from 'react';
import { Avatar, Box, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Stack, SvgIcon} from '@mui/material';
import { useLocation } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Sparkle from 'react-sparkle'

export default function Activities() {

    const {state} = useLocation()

    const [rows, setRows] =  React.useState(state)


    function timeStampToDate(unix_timestamp){

        const timestamp = unix_timestamp
        // Create a new JavaScript Date object based on the timestamp
        // multiplied by 1000 so that the argument is in milliseconds, not seconds
        var date = new Date(timestamp * 1000);

        // Hours part from the timestamp
        const year = date.getFullYear();

        // Minutes part from the timestamp
        const month = "0" + date.getMonth();

        // Seconds part from the timestamp
        const day = "0" + date.getDay();

        // Will display time in 10:30:23 format
        var formattedTime = day + '/' + month + '/' + year;

        return formattedTime
    }



    return (
        <Box sx={{ height: '100%', py:8 }}>  
            <List sx={{ width: '100%'}}>
                {rows?.map((row,  i) => (   
                    <ListItem alignItems="flex-start" key={i}>
                        <ListItemButton>
                            <ListItemText
                                primary={ 
                                <Stack>
                                     <Stack spacing={1} direction={"row"}>
                                        <Typography
                                            component="span"
                                            variant="h6"
                                            fontWeight="bolder"
                                            sx={{ color: 'black', display: 'inline' }}
                                        >
                                            {row.nombre}
                                        </Typography>
                                        <Typography
                                                component="span"
                                                 variant="h6"
                                            fontWeight="bolder"
                                                sx={{ color: 'orange', display: 'inline' }}
                                            >
                                               (Tienes un codigo)
                                               <Sparkle
                                                color="orange"
                                                count={5}
                                                minSize={20}
                                                maxSize={12}
                                                overflowPx={0}
                                                fadeOutSpeed={10}
                                                flicker={false}
                                                />
                                        </Typography>
                                       
                                    </Stack>
                                    <Stack spacing={1} direction={"row"}>
                                        <Typography
                                            component="span"
                                            variant="subtitle1"
                                            fontWeight="bolder"
                                            sx={{ color: 'black', display: 'inline' }}
                                        >
                                            {"Fecha:  "}
                                        </Typography>
                                        <Typography
                                            component="span"
                                            variant="subtitle1"
                                            sx={{ color: 'black', display: 'inline' }}
                                        >
                                             {timeStampToDate(row.fecha._seconds)}
                                        </Typography>
                                    </Stack>
                                   
                                </Stack>
                                }
                                secondary={
                                    <>
                                    <Typography
                                        component="span"
                                        variant="subtitle1"
                                        sx={{ color: 'black', display: 'inline' }}
                                    >
                                        {row.marca}
                                        
                                    </Typography>
                                  
                                    </>
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    )
}